import {SET_HOMOLOGATION_STATUS} from "./constants";
import {globalCatch} from "../../../_services/global-catch";
import {lazySingleton} from "../../../_common/common";
import StudentAccountService from "../../../_services/student-account-service";
import {downloadFile} from "../../../utils";
import {TOKEN_EXPEDIENT} from "../../../constants";


export const setHomologationStatus = payload => ({ type: SET_HOMOLOGATION_STATUS, payload });

const svcStudent = lazySingleton(()=>new StudentAccountService());

export const getHomologationStatus = (studentId) => globalCatch.catch(async dispatch => {
   const homologationStatus = await (await svcStudent().getHomologationStatus(studentId));
   dispatch(setHomologationStatus(homologationStatus));
   return homologationStatus;
});

export const downloadHomologation = (studentId, documentId, fileName) => {
   return downloadFile({
      url: `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/account/students/${studentId}/documents/homologation/${documentId}`,
      fileName: fileName,
      TOKEN: TOKEN_EXPEDIENT
   });
};
